import { useState, useRef, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import spinner from "../../../assets/iconos/spinner4.svg";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { obtenerListaEmpresaPlataforma, } from "../../../api/api-empresa-plataforma";
import { getListTipoVehiculo } from "../../../api/api-tipo-vehiculo";
import { getListMarca } from "../../../api/api-marca";
import { getListModeloCombo } from "../../../api/api-modelo";
import { ESTILO_BOTON_LISTAR_ATRAS, ESTILO_EFECTO_LUZ, ESTILO_EFECTO_SIN_LUZ } from "../../../utils/const/estilos-const";
import { getListFuel } from "../../../api/api-fuel";
import { getListVoltajeBateria } from "../../../api/api-voltaje-bateria";
import { getListTraccion } from "../../../api/api-traccion";
import { getListGrupoByIdEmpresaPlataforma } from "../../../api/api-grupo";
import { getListSubGrupoCombo } from "../../../api/api-sub-grupo";
import { createVehiculo, updateVehiculo } from "../../../api/api-vehiculo";
import { COLORS_VALUES, useColors } from "../../../utils/const/colors-const";

import iconoAutoAzul from "../../../assets/iconos/iconoAutoAzul.svg";
// import iconoCamionAzul from "./iconoCamionAzul.svg";
import iconoCamionetaAzul from "../../../assets/iconos/iconoCamionetaAzul.svg";
import iconoMotoAzul from "../../../assets/iconos/iconoMotoAzul.svg";
import iconoTractoCamionAzul from "../../../assets/iconos/iconoTractorCamionAzul.svg";
import iconoTractorAzul from "../../../assets/iconos/iconoTractorAzul.svg";
import iconoJeepAzul from "../../../assets/iconos/iconoJeepAzul.svg";
import iconoMicroBusAzul from "../../../assets/iconos/iconoMicroBusAzul.svg";

import iconoAutoRojo from "../../../assets/iconos/iconoAutoRojo.svg";
// import iconoCamionRojo from "./iconoCamionRojo.svg";
import iconoCamionetaRojo from "../../../assets/iconos/iconoCamionetaRojo.svg";
import iconoMotoRojo from "../../../assets/iconos/iconoMotoRojo.svg";
import iconoTractoCamionRojo from "../../../assets/iconos/iconoTractorCamionRojo.svg";
import iconoTractorRojo from "../../../assets/iconos/iconoTractorRojo.svg";
import iconoJeepRojo from "../../../assets/iconos/iconoJeepRojo.svg";
import iconoMicroBusRojo from "../../../assets/iconos/iconoMicroBusRojo.svg";

import iconoAutoVerde from "../../../assets/iconos/iconoAutoVerde.svg";
// import iconoCamionVerde from "./iconoCamionVerde.svg";
import iconoCamionetaVerde from "../../../assets/iconos/iconoCamionetaVerde.svg";
import iconoMotoVerde from "../../../assets/iconos/iconoMotoVerde.svg";
import iconoTractoCamionVerde from "../../../assets/iconos/iconoTractorCamionVerde.svg";
import iconoTractorVerde from "../../../assets/iconos/iconoTractorVerde.svg";
import iconoJeepVerde from "../../../assets/iconos/iconoJeepVerde.svg";
import iconoMicroBusVerde from "../../../assets/iconos/iconoMicroBusVerde.svg";

import iconoAutoAmarillo from "../../../assets/iconos/iconoAutoAmarillo.svg";
// import iconoCamionAmarillo from "./iconoCamionAmarillo.svg";
import iconoCamionetaAmarillo from "../../../assets/iconos/iconoCamionetaAmarillo.svg";
import iconoMotoAmarillo from "../../../assets/iconos/iconoMotoAmarillo.svg";
import iconoTractoCamionAmarillo from "../../../assets/iconos/iconoTractorCamionAmarillo.svg";
import iconoTractorAmarillo from "../../../assets/iconos/iconoTractorAmarillo.svg";
import iconoJeepAmarillo from "../../../assets/iconos/iconoJeepAmarillo.svg";
import iconoMicroBusAmarillo from "../../../assets/iconos/iconoMicroBusAmarillo.svg";
import { getListConceptoDocumentosVehiculo } from "../../../api/api-concepto-documentos-vehiculo";

import { STRING_PATH_SAVE_FILES } from "../../../utils/const/string-const";
import { uploadFile } from "../../../api/api-image";
import shortid from "shortid";
import { QUERY_INSERT, QUERY_UPDATE } from "../../../utils/const/http-const";
import ButtonAddFileComponent from "../../../components/button-add-file-component";
import ButtonLoadingComponent from "../../../components/button-loading-component";

export default function Vehicle() {
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const fileInputRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const [cargandoPage, setCargandoPage] = useState(true);

    const [listEmpresaPlataforma, setListEmpresaPlataforma] = useState([]);
    const [empresaPlataformaSelected, setEmpresaPlataformaSelected] = useState(null);

    const [listTipoVehiculo, setListTipoVehiculo] = useState([]);
    const [tipoVehiculoSelected, setTipoVehiculoSelected] = useState(null);

    const [listMarca, setListMarca] = useState([]);
    const [marcaSelected, setMarcaSelected] = useState(null);

    const [listModelo, setListModelo] = useState([]);
    const [modeloSelected, setModeloSelected] = useState(null);

    const [listTipoCombustible, setListTipoCombustible] = useState([]);
    const [tipoCombustibleSelected, setTipoCombustibleSelected] = useState(null);

    const [listVoltajeBateria, setListVoltajeBateria] = useState([]);
    const [voltajeBateriaSelected, setVoltajeBateriaSelected] = useState(null);

    const [listTraccion, setListTraccion] = useState([]);
    const [traccionSelected, setTraccionSelected] = useState(null);

    const [listGrupo, setListGrupo] = useState([]);
    const [grupoSelected, setGrupoSelected] = useState(null);

    const [listSubGrupo, setListSubGrupo] = useState([]);
    const [subGrupoSelected, setSubGrupoSelected] = useState(null);

    const listColor = useColors();
    const [colorSelected, setColorSelected] = useState(null);
    const [iconSelected, setIconSelected] = useState(null);

    const [listDocumentos, setListDocumentos] = useState([]);
    const [documentoSelected, setDocumentoSelected] = useState(null);

    const [uploadingFile, setUploadingFile] = useState(false);

    const [formData, setFormData] = useState({
        placa: "",
        codigo: '',
        nombre: '',
        anio: "",
        telefonoEmpresa: '',
        emailEmpresa: '',
        representante: '',
        telefonoRepresentante: '',
        emailRepresentante: '',
        timeZone: '',
        nroChasis: "",
        motor: "",
        cilindrada: 0,
        capacidadCarga: 0,
        capacidadVolumen: 0,
        capacidadTanque: 0,
        rendimientoKML: "",
        colorVehiculo: "",
        documents: [],
    });

    const charLimits = {
        placa: 32,
        codigo: 32,
        nombre: 32,
        anio: 4,
        telefonoEmpresa: 64,
        emailEmpresa: 64,
        representante: 128,
        telefonoRepresentante: 64,
        emailRepresentante: 64,
        timeZone: 8,
        nroChasis: 24,
        motor: 24,
        cilindrada: 6,
        capacidadCarga: 6,
        capacidadVolumen: 6,
        capacidadTanque: 6,
        rendimientoKML: 5,
        colorVehiculo: 8,
    };

    useEffect(() => {
        // const fileUpload = document.getElementById("fileUpload");
        // fileUpload.addEventListener("change", () => {
        //     console.log(fileUpload.files[0]);
        // });
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const data = location.state;
            // console.log("data");
            // console.log(data);
            if (data !== undefined && data !== null) {
                setFormData((prevState) => ({
                    ...prevState,
                    ...data.params
                }));
            }
            const empresaPlatafomra = await obtenerListaEmpresaPlataforma({ habilitado: 1 }, true, t);
            // console.log('empresaPlatafomra');
            // console.log(empresaPlatafomra);
            setListEmpresaPlataforma(empresaPlatafomra);
            if (data.params.idEmpresaPlataforma !== null && String(data.params.idEmpresaPlataforma).length > 0) {
                const emp = empresaPlatafomra.find(e => e.value === data.params.idEmpresaPlataforma);
                // console.log('emp');
                // console.log(emp);
                setEmpresaPlataformaSelected(emp);
            }

            const tipoVehiculo = await getListTipoVehiculo({ habilitado: 1 }, true, t);
            // console.log('tipoVehiculo');
            // console.log(tipoVehiculo);
            setListTipoVehiculo(tipoVehiculo);
            if (String(data.params.idTipoVehiculo).length > 0) {
                const param = tipoVehiculo.find(e => e.value === data.params.idTipoVehiculo);
                // console.log('emp');
                // console.log(emp);
                setTipoVehiculoSelected(param);
            }

            const marca = await getListMarca({ habilitado: 1 }, true, t);
            // console.log('marca');
            // console.log(marca);
            setListMarca(marca);
            if (data.params.idMarca !== null && String(data.params.idMarca).length > 0) {
                const param = marca.find(e => e.value === data.params.idMarca);
                // console.log('emp');
                // console.log(emp);
                setMarcaSelected(param);

                const modelo = await getListModeloCombo({ idMarca: data.params.idMarca });
                // console.log('modelo');
                // console.log(modelo);
                setListModelo(modelo);
                const modeloParam = modelo.find(e => e.value === data.params.idModelo);
                // console.log('emp');
                // console.log(emp);
                setModeloSelected(modeloParam);
            }

            const tipoCombustible = await getListFuel({ habilitado: 1 }, true, t);
            // console.log('tipoCombustible');
            // console.log(tipoCombustible);
            setListTipoCombustible(tipoCombustible);
            if (String(data.params.idTipoCombustible).length > 0) {
                const param = tipoCombustible.find(e => e.value === data.params.idTipoCombustible);
                // console.log('emp');
                // console.log(emp);
                setTipoCombustibleSelected(param);
            }

            const voltajeBateria = await getListVoltajeBateria({ habilitado: 1 }, true, t);
            setListVoltajeBateria(voltajeBateria);
            if (String(data.params.idVoltajeBateria).length > 0) {
                const param = voltajeBateria.find(e => e.value === data.params.idVoltajeBateria);
                // console.log('emp');
                // console.log(emp);
                setVoltajeBateriaSelected(param);
            }

            const traccion = await getListTraccion({ habilitado: 1 }, true, t);
            setListTraccion(traccion);
            if (String(data.params.idTraccion).length > 0) {
                const param = traccion.find(e => e.value === data.params.idTraccion);
                // console.log('emp');
                // console.log(emp);
                setTraccionSelected(param);
            }

            if (data.params.idGrupo !== null && String(data.params.idGrupo).length > 0) {
                const grupo = await getListGrupoByIdEmpresaPlataforma({ idEmpresaPlataforma: data.params.idEmpresaPlataforma });
                setListGrupo(grupo);

                const param = grupo.find(e => e.value === data.params.idGrupo);
                // console.log('emp');
                // console.log(emp);
                setGrupoSelected(param);
                const subGrupo = await getListSubGrupoCombo({ idGrupo: data.params.idGrupo });
                setListSubGrupo(subGrupo);
                const paramSubGrupo = subGrupo.find(e => e.value === data.params.idSubgrupo);
                // console.log('emp');
                // console.log(emp);
                setSubGrupoSelected(paramSubGrupo);
            }

            // console.log('listColor');
            // console.log(listColor);
            if (data.params.colorIcono !== null) {
                const color = listColor.find(e => e.value === data.params.colorIcono);
                // console.log('color');
                // console.log(color);
                setColorSelected(color);
                setIconSelected(data.params.icono);
            }

            const documents = await getListConceptoDocumentosVehiculo({ habilitado: 1 }, true, t);
            setListDocumentos(documents);

            setCargandoPage(false);
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
            setCargandoPage(false);
        }
    };

    useEffect(() => {
        onChangeMarcaSelected();
    }, [marcaSelected]);

    const onChangeMarcaSelected = async () => {
        if (marcaSelected === null) {
            setMarcaSelected(null);
            setModeloSelected(null);
        }
        if (marcaSelected !== null) {
            setModeloSelected(null);
            const modelo = await getListModeloCombo({ idMarca: marcaSelected.value });
            setListModelo(modelo);
        }
    };

    useEffect(() => {
        onChangeGrupoSelected();
    }, [grupoSelected]);

    const onChangeGrupoSelected = async () => {
        if (grupoSelected === null) {
            setGrupoSelected(null);
            setSubGrupoSelected(null);
        }
        if (grupoSelected !== null) {
            setSubGrupoSelected(null);
            const subGrupo = await getListSubGrupoCombo({ idGrupo: grupoSelected.value });
            setListSubGrupo(subGrupo);
        }
    };

    useEffect(() => {
        onChangeEmpresaPlataformaSelected();
    }, [empresaPlataformaSelected]);

    const onChangeEmpresaPlataformaSelected = async () => {
        if (empresaPlataformaSelected === null) {
            setListGrupo([]);
            setListSubGrupo([]);
            setGrupoSelected(null);
            setSubGrupoSelected(null);
        }
        if (empresaPlataformaSelected !== null) {
            setListGrupo([]);
            setGrupoSelected(null);
            setListSubGrupo([]);
            setSubGrupoSelected(null);
            const grupo = await getListGrupoByIdEmpresaPlataforma({ idEmpresaPlataforma: empresaPlataformaSelected.value });
            setListGrupo(grupo);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (value.length <= charLimits[name]) {
            setFormData({
                ...formData,
                [name]: value,
            });
        }
    };

    const handleAtrasClick = () => {
        history.goBack();
    };

    const validar = () => {
        try {
            // console.log('validar');
            // console.log(formData);
            let result = { error: true, message: "" };
            let message = "";
            if (formData.placa.trim().length === 0) {
                message = message + t("alert_must_enter_licence_place") + "\n";
            }
            if (formData.nombre.trim().length === 0) {
                message = message + t("alert_must_enter_name_label") + '\n';
            }
            if (tipoVehiculoSelected === null) {
                message = message + t("alert_must_enter_type_vehicle") + '\n';
            }
            if (marcaSelected === null) {
                message = message + t("alert_must_select_brand_vehicle") + '\n';
            }
            if (modeloSelected === null) {
                message = message + t("alert_must_select_vehicle_model") + '\n';
            }
            if (String(formData.anio).trim().length === 0) {
                message = message + t("alert_must_enter_year") + '\n';
            }
            if (tipoCombustibleSelected === null) {
                message = message + t("alert_must_select_type_fuel") + '\n';
            }
            if (voltajeBateriaSelected === null) {
                message = message + t("alert_must_select_batery_voltage") + '\n';
            }
            if (traccionSelected === null) {
                message = message + t("alert_must_select_vehicle_traction") + '\n';
            }
            if (grupoSelected === null) {
                message = message + t("alert_must_select_vehicle_group") + '\n';
            }
            if (subGrupoSelected === null) {
                message = message + t("alert_must_select_vehicle_sub_group") + '\n';
            }
            if (colorSelected === undefined || colorSelected === null) {
                message = message + t("alert_must_select_marker_color") + '\n';
            }
            if (iconSelected === null) {
                message = message + t("alert_must_select_vehicle_icon") + '\n';
            }
            if (message.length > 0) {
                result.error = true;
                result.message = message;
            } else {
                result.error = false;
            }
            return result;
        } catch (err) {
            return { error: true, message: err };
        }
    };

    const handleSave = async () => {
        try {
            // console.log('handleSave');
            // console.log(formData);
            const isValid = validar();
            if (isValid.error === true) {
                alert(isValid.message);
                return;
            }
            // return;
            if (isValid.error === false) {
                saveVehicle();
            } else {
                alert(isValid.message);
            }
            setLoading(false);
        } catch (err) {
            console.log('handleSave err');
            console.log(err);
            setLoading(false);
        }
    };

    const saveVehicle = async () => {
        try {
            // console.log('saveVehicle');
            // console.log(formData);
            // console.log('colorSelected', colorSelected);
            // return;
            setLoading(true);
            let objEnviar = {};
            objEnviar.id = formData.id;
            objEnviar.codigo = formData.codigo;
            objEnviar.placa = formData.placa;
            objEnviar.nombre = formData.nombre;
            objEnviar.idTipoVehiculo = tipoVehiculoSelected.value;
            objEnviar.idMarca = marcaSelected.value;
            objEnviar.idModelo = modeloSelected.value;
            objEnviar.idTipoCombustible = tipoCombustibleSelected.value;
            objEnviar.idVoltajeBateria = voltajeBateriaSelected.value;
            objEnviar.idTraccion = traccionSelected.value;
            objEnviar.anio = formData.anio;
            objEnviar.idGrupo = grupoSelected.value;
            objEnviar.idSubgrupo = subGrupoSelected.value;
            objEnviar.idEmpresaPlataforma = empresaPlataformaSelected.value;
            objEnviar.propietario = empresaPlataformaSelected.label;
            objEnviar.nroChasis = formData.nroChasis;
            objEnviar.motor = formData.motor;
            objEnviar.cilindrada = formData.cilindrada;
            objEnviar.capacidadTanque = formData.capacidadTanque;
            objEnviar.capacidadCarga = formData.capacidadCarga;
            objEnviar.capacidadVolumen = formData.capacidadVolumen;
            objEnviar.rendimientoKML = formData.rendimientoKML;
            objEnviar.colorIcono = colorSelected !== null ? colorSelected.value : null;
            objEnviar.iconSelected = iconSelected;
            objEnviar.colorVehiculo = formData.colorVehiculo;
            objEnviar.documents = formData.documents;
            // console.log('objEnviar');
            // console.log(objEnviar);
            // return;
            if (objEnviar.id === 0) {
                // console.log('actualizar correo');
                const resp = await createVehiculo(objEnviar);
                // console.log('modificado');
                // console.log(modificado);
                if (resp.error === false) {
                    alert(t("alert_created_success"));
                    handleAtrasClick();
                }
                if (resp.error === true) {
                    alert(t("alert_failed") + "\n" + resp.message);
                }
            }
            if (objEnviar.id !== 0) {
                // console.log('actualizar correo');
                const resp = await updateVehiculo(objEnviar);
                // console.log('modificado');
                // console.log(modificado);
                if (resp.error === false) {
                    alert(t("alert_created_success"));
                    handleAtrasClick();
                }
                if (resp.error === true) {
                    alert(t("alert_failed") + "\n" + resp.message);
                }
            }
            setLoading(false);
        } catch (err) {
            console.log('saveVehicle');
            console.log(err);
            setLoading(false);
        }
    };

    const changeSelectedIcon = (element) => {
        const value = element.getAttribute("value");
        // console.log('changeSelectedIcon');
        // console.log(value);
        setIconSelected(parseInt(value));
    };

    const renderDocuments = () => {
        try {
            // console.log('renderDocuments');
            // console.log(formData);
            if (Array.isArray(formData.documents) === true) {
                return (
                    <>
                        {formData.documents.map((item) => (
                            item.habilitado === true || item.habilitado === 1 ?
                                <div
                                    key={item.id}
                                    className="grid grid-cols-12 gap-4 p-4 mb-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200"
                                >
                                    <div className="col-span-8 md:col-span-6 lg:col-span-2 xl:col-span-2 flex items-center">
                                        {item.label}
                                    </div>
                                    <div className="col-span-8 md:col-span-6 lg:col-span-8 xl:col-span-8 flex items-center">
                                        <a
                                            href={item.urlFile}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-blue-600 hover:text-blue-800 hover:underline cursor-pointer truncate"
                                            title="Click to view file"
                                        >
                                            {item.fileName}
                                        </a>
                                    </div>
                                    <div className="col-span-4 md:col-span-6 lg:col-span-2 xl:col-span-2 flex justify-end items-center space-x-2">
                                        <button
                                            onClick={() => handleDownloadFile(item)}
                                            className="text-green-600 hover:text-green-800 p-2 rounded-full hover:bg-green-50 transition-colors duration-200"
                                            title="Download file"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                                                />
                                            </svg>
                                        </button>
                                        <button
                                            onClick={() => handleDeleteFile(item)}
                                            className="text-red-500 hover:text-red-700 p-2 rounded-full hover:bg-red-50 transition-colors duration-200"
                                            title="Delete file"
                                        >
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-5 w-5"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                                : null
                        ))}
                    </>
                );
            }
            return null;
        } catch (err) {
            console.log('renderDocuments err');
            return null;
        }
    };

    const handleAddDocument = () => {
        try {
            if (documentoSelected === null) {
                alert(t('alert_must_choose_document'));
                return;
            }
            fileInputRef.current.click();
        } catch (err) {
            console.log('handleAddDocument err');
            console.log(err);
        }
    };

    const handleFileChange = (event) => {
        try {
            // console.log('handleFileChange');
            const file = event.target.files[0];
            if (!file) return;

            // Validate file type
            const validTypes = ['image/jpeg', 'image/png', 'application/pdf'];
            if (!validTypes.includes(file.type)) {
                alert(t('alert_types_allowed'));
                return;
            }
            // Validate file size (5MB max)
            if (file.size > 5 * 1024 * 1024) {
                alert(t('alert_only_5_mb_allow'));
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                let base64 = reader.result;
                const pureBase64 = base64.split(',')[1];
                saveFile(pureBase64, file.type, file.name);
                event.target.value = '';
            };
            reader.readAsDataURL(file);
        } catch (err) {
            console.log('handleFileChange err');
            console.log(err);
        }
    };

    const saveFile = async (base64, fileType, fileName) => {
        try {
            // console.log('File name:', fileName);
            // console.log('File type:', fileType);
            // console.log('Base64:', base64);
            setUploadingFile(true);
            let objEnviar = {};
            objEnviar.id = shortid.generate();
            objEnviar.idBase = 0;
            objEnviar.fileType = fileType;
            objEnviar.base64 = base64;
            objEnviar.fileName = fileName;
            objEnviar.path = STRING_PATH_SAVE_FILES;
            objEnviar.habilitado = true;
            objEnviar.label = documentoSelected.label;
            objEnviar.idConceptoDocumentoVehiculo = documentoSelected.value;
            objEnviar.idEmpresaPlataforma = empresaPlataformaSelected.value;
            objEnviar.query = QUERY_INSERT;
            const response = await uploadFile(objEnviar);
            // console.log('response', response);
            if (response !== null) {
                objEnviar.urlFile = response;
            }
            const currentDocuments = [...formData.documents];
            currentDocuments.push(objEnviar);
            setFormData({
                ...formData,
                documents: currentDocuments,
            });
            setUploadingFile(false);
        } catch (err) {
            console.log('saveFile err');
            console.log(err);
            setUploadingFile(false);
        }
    };

    const handleDeleteFile = (fileObject) => {
        // console.log('handleDeleteFile', fileObject);
        // return;
        if (fileObject.query === QUERY_INSERT && fileObject.idBase === 0) {
            setFormData(prevFormData => ({
                ...prevFormData,
                documents: prevFormData.documents.filter(item => item.id !== fileObject.id)
            }));
        }
        if (fileObject.query === QUERY_UPDATE && fileObject.idBase !== 0) {
            setFormData(prevFormData => ({
                ...prevFormData,
                documents: prevFormData.documents.map(item =>
                    item.id === fileObject.id
                        ? { ...item, habilitado: 0 }
                        : item
                )
            }));
        }
    };

    const handleDownloadFile = async (fileItem) => {
        try {
            const response = await fetch(fileItem.url);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = fileItem.fileName || 'download';
            document.body.appendChild(link);
            link.click();

            // Cleanup
            window.URL.revokeObjectURL(url);
            document.body.removeChild(link);
        } catch (error) {
            console.error('Download failed:', error);
            alert('Download failed. Please try again.');
        }
    };

    const render = () => {

        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (cargandoPage === false && formData === null) {
                return (
                    <div>
                        <label> Sin data</label>
                    </div>
                );
            }
            return (
                <div className="p-4 bg-white rounded-lg">
                    <div className="w-full flex items-center justify-between ">
                        <h2 className="text-2xl font-bold text-[#0F3457] mb-6">{t("label_nuevo_vehiculo")}</h2>
                        <button
                            type="button"
                            className={ESTILO_BOTON_LISTAR_ATRAS}
                            onClick={(handleAtrasClick)}
                        >
                            {t("label_back")}
                        </button>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="empresaCliente">
                                {t("label_empresa_plataforma")}
                            </label>
                            <Select
                                options={listEmpresaPlataforma}
                                isSearchable={true}
                                isClearable={true}
                                value={empresaPlataformaSelected}
                                onChange={(event) => setEmpresaPlataformaSelected(event)}
                                placeholder={t("label_select_empresa_plataforma")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                    </div>
                    <hr className="mt-2" />
                    <br />
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="codigo">
                                    {t("code")}
                                </label>
                                <input
                                    type="text"
                                    id="codigo"
                                    name="codigo"
                                    value={formData.codigo}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Codigo"
                                    maxLength={charLimits.codigo}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.codigo.length}/{charLimits.codigo}</p>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="placa">
                                    {t("licence_place")}<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="placa"
                                    name="placa"
                                    value={formData.placa}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Nombre"
                                    maxLength={charLimits.placa}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.placa.length}/{charLimits.placa}</p>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nameCompany">
                                    {t("label_nombre")}/Label<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="text"
                                    id="nombre"
                                    name="nombre"
                                    value={formData.nombre}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder="Nombre"
                                    maxLength={charLimits.nombre}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.nombre.length}/{charLimits.nombre}</p>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="tipoVehiculo">
                                {t("label_type_vehicle")}<span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={listTipoVehiculo}
                                isSearchable={true}
                                isClearable={true}
                                value={tipoVehiculoSelected}
                                onChange={(event) => setTipoVehiculoSelected(event)}
                                placeholder={t("label_select_tipo_vehiculo")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="marca">
                                {t("label_marca")}<span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={listMarca}
                                isSearchable={true}
                                isClearable={true}
                                value={marcaSelected}
                                onChange={(event) => setMarcaSelected(event)}
                                placeholder={t("label_select_marca")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="modelo">
                                {t("label_model")}<span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={listModelo}
                                isSearchable={true}
                                isClearable={true}
                                value={modeloSelected}
                                onChange={(event) => setModeloSelected(event)}
                                placeholder={t("label_select_modelo")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="anio">
                                    {t("label_anio")}<span className="text-red-500">*</span>
                                </label>
                                <input
                                    type="number"
                                    id="anio"
                                    name="anio"
                                    value={formData.anio}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder={t("label_anio")}
                                    maxLength={charLimits.anio}
                                    min={0}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.anio.length}/{charLimits.anio}</p>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="tipoCombustible">
                                {t("label_type_fuel")}<span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={listTipoCombustible}
                                isSearchable={true}
                                isClearable={true}
                                value={tipoCombustibleSelected}
                                onChange={(event) => setTipoCombustibleSelected(event)}
                                placeholder={t("label_select_type_fuel")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                    </div>
                    {/* <br /> */}
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="voltajeBateria">
                                {t("label_battery_voltage")}<span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={listVoltajeBateria}
                                isSearchable={true}
                                isClearable={true}
                                value={voltajeBateriaSelected}
                                onChange={(event) => setVoltajeBateriaSelected(event)}
                                placeholder={t("label_select_battery_voltage")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="traccion">
                                {t("label_traction")}<span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={listTraccion}
                                isSearchable={true}
                                isClearable={true}
                                value={traccionSelected}
                                onChange={(event) => setTraccionSelected(event)}
                                placeholder={t("label_select_traction")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="grupo">
                                {t("label_grupo")}<span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={listGrupo}
                                isSearchable={true}
                                isClearable={true}
                                value={grupoSelected}
                                onChange={(event) => setGrupoSelected(event)}
                                placeholder={t("label_select_grupo")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="subGrupo">
                                {t("label_sub_grupo")}<span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={listSubGrupo}
                                isSearchable={true}
                                isClearable={true}
                                value={subGrupoSelected}
                                onChange={(event) => setSubGrupoSelected(event)}
                                placeholder={t("label_select_sub_grupo")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                    </div>
                    <hr className="mt-2" />
                    <br />
                    <label className="font-bold">{t("title_aditional_information")}</label>
                    <div className="grid grid-cols-12 gap-4 mt-2">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="nroChasis">
                                    {t("label_numero_chasis")}
                                </label>
                                <input
                                    type="text"
                                    id="nroChasis"
                                    name="nroChasis"
                                    value={formData.nroChasis}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder={t("placeholder_enter_chasis")}
                                    maxLength={charLimits.nroChasis}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.nroChasis?.length}/{charLimits.nroChasis}</p>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="motor">
                                    {t("label_numero_motor")}
                                </label>
                                <input
                                    type="text"
                                    id="motor"
                                    name="motor"
                                    value={formData.motor}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder={t("placeholder_enter_motor")}
                                    maxLength={charLimits.motor}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.motor?.length}/{charLimits.motor}</p>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="cilindrada">
                                    {t("label_cilindrada")}
                                </label>
                                <input
                                    type="number"
                                    id="cilindrada"
                                    name="cilindrada"
                                    value={formData.cilindrada}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder={t("placeholder_enter_cilindrada")}
                                    maxLength={charLimits.cilindrada}
                                    min={0}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.cilindrada?.length}/{charLimits.cilindrada}</p>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="capacidadTanque">
                                    {t("label_capacidad_tanque")}
                                </label>
                                <input
                                    type="number"
                                    id="capacidadTanque"
                                    name="capacidadTanque"
                                    value={formData.capacidadTanque}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder={t("placeholder_enter_capacidad_tanque")}
                                    maxLength={charLimits.capacidadTanque}
                                    min={0}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.capacidadTanque?.length}/{charLimits.capacidadTanque}</p>
                            </div>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4 mt-2">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="capacidadCarga">
                                    {t("label_capacidad_carga")}
                                </label>
                                <input
                                    type="number"
                                    id="capacidadCarga"
                                    name="capacidadCarga"
                                    value={formData.capacidadCarga}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder={t("placeholder_enter_capacidad_carga")}
                                    maxLength={charLimits.capacidadCarga}
                                    min={0}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.capacidadCarga?.length}/{charLimits.capacidadCarga}</p>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="capacidadVolumen">
                                    {t("label_capacidad_volumen")}
                                </label>
                                <input
                                    type="number"
                                    id="capacidadVolumen"
                                    name="capacidadVolumen"
                                    value={formData.capacidadVolumen}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder={t("placeholder_enter_capacidad_volumen")}
                                    maxLength={charLimits.capacidadVolumen}
                                    min={0}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.capacidadVolumen?.length}/{charLimits.capacidadVolumen}</p>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="color">
                                    {t("label_performance_kml_ml")}
                                </label>
                                <input
                                    type="text"
                                    id="rendimientoKML"
                                    name="rendimientoKML"
                                    value={formData.rendimientoKML}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder={"Enter Value"}
                                    maxLength={charLimits.rendimientoKML}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData.rendimientoKML.length}/{charLimits.rendimientoKML}</p>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <div className="mb-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="color">
                                    {t("label_vehicle_color")}
                                </label>
                                <input
                                    type="text"
                                    id="colorVehiculo"
                                    name="colorVehiculo"
                                    value={formData?.colorVehiculo}
                                    onChange={handleChange}
                                    className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-[#84B044]"
                                    placeholder={"Enter Value"}
                                    maxLength={charLimits.colorVehiculo}
                                />
                                <p className="text-sm text-gray-500 flex justify-end">{formData?.colorVehiculo?.length}/{charLimits.colorVehiculo}</p>
                            </div>
                        </div>
                    </div>
                    <hr className="mt-2" />
                    <br />
                    <label className="font-bold">{t("title_aditional_custom")}</label>
                    <div className="grid grid-cols-12 gap-4 mt-2">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="empresaCliente">
                                {t("label_color_marker")}<span className="text-red-500">*</span>
                            </label>
                            <Select
                                options={listColor}
                                isSearchable={true}
                                isClearable={true}
                                value={colorSelected}
                                onChange={(event) => {
                                    setIconSelected(null);
                                    setColorSelected(event);
                                }}
                                placeholder={t("label_select_color")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4 mt-2">
                        <div className="col-span-12">
                            {colorSelected !== null && colorSelected?.value === COLORS_VALUES.blue &&
                                <div
                                    style={{
                                        display: "flex",
                                        marginLeft: "10px",
                                        justifyContent: "space-around",
                                    }}
                                >
                                    <div
                                        id="iconAuto"
                                        value={2}
                                        className={iconSelected === 2 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoAutoAzul} />
                                    </div>
                                    <div
                                        id="iconCamioneta"
                                        value={3}
                                        className={iconSelected === 3 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoCamionetaAzul} />
                                    </div>
                                    <div
                                        id="iconTractoCamion"
                                        value={1}
                                        className={iconSelected === 1 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoTractoCamionAzul} />
                                    </div>
                                    <div
                                        id="iconTractor"
                                        value={5}
                                        className={iconSelected === 5 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoTractorAzul} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconMoto"
                                        value={25}
                                        className={iconSelected === 25 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoMotoAzul} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconSuv"
                                        value={29}
                                        className={`${iconSelected === 29 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}`}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoJeepAzul} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconBus"
                                        value={21}
                                        className={`${iconSelected === 21 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}`}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoMicroBusAzul} className="w-full h-full object-contain" alt="bus" />
                                    </div>
                                </div>
                            }
                            {colorSelected !== null && colorSelected?.value === COLORS_VALUES.red &&
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-around",
                                        marginLeft: "10px",
                                    }}
                                >
                                    <div
                                        id="iconAuto"
                                        value={7}
                                        className={iconSelected === 7 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoAutoRojo} />
                                    </div>
                                    <div
                                        id="iconCamioneta"
                                        value={8}
                                        className={iconSelected === 8 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoCamionetaRojo} />
                                    </div>
                                    <div
                                        id="iconTractoCamion"
                                        value={6}
                                        className={iconSelected === 6 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoTractoCamionRojo} />
                                    </div>
                                    <div
                                        id="iconTractor"
                                        value={10}
                                        className={iconSelected === 10 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoTractorRojo} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconMoto"
                                        value={27}
                                        className={iconSelected === 27 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoMotoRojo} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconSuv"
                                        value={31}
                                        className={iconSelected === 31 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoJeepRojo} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconBus"
                                        value={23}
                                        className={iconSelected === 23 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoMicroBusRojo} className="img" alt="bus" />
                                    </div>
                                </div>
                            }
                            {colorSelected !== null && colorSelected?.value === COLORS_VALUES.green &&
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-around",
                                        marginLeft: "10px",
                                    }}
                                >
                                    <div
                                        id="iconAuto"
                                        value={17}
                                        className={iconSelected === 17 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoAutoVerde} />
                                    </div>
                                    <div
                                        id="iconCamioneta"
                                        value={18}
                                        className={iconSelected === 18 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoCamionetaVerde} />
                                    </div>
                                    <div
                                        id="iconTractoCamion"
                                        value={16}
                                        className={iconSelected === 16 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoTractoCamionVerde} />
                                    </div>
                                    <div
                                        id="iconTractor"
                                        value={20}
                                        className={iconSelected === 20 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoTractorVerde} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconMoto"
                                        value={26}
                                        className={iconSelected === 26 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoMotoVerde} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconSuv"
                                        value={30}
                                        className={iconSelected === 30 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoJeepVerde} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconBus"
                                        value={222}
                                        className={iconSelected === 222 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoMicroBusVerde} className="img" alt="bus" />
                                    </div>
                                </div>
                            }
                            {colorSelected !== null && colorSelected?.value === COLORS_VALUES.yellow &&
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "space-around",
                                        marginLeft: "10px",
                                    }}
                                >
                                    <div
                                        id="iconAuto"
                                        value={12}
                                        className={iconSelected === 12 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoAutoAmarillo} />
                                    </div>
                                    <div
                                        id="iconTractoCamion"
                                        value={11}
                                        className={iconSelected === 11 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoTractoCamionAmarillo} />
                                    </div>
                                    <div
                                        id="iconCamioneta"
                                        value={13}
                                        className={iconSelected === 13 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoCamionetaAmarillo} />
                                    </div>
                                    <div
                                        id="iconTractor"
                                        value={15}
                                        className={iconSelected === 15 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoTractorAmarillo} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconMoto"
                                        value={28}
                                        className={iconSelected === 28 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoMotoAmarillo} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconSuv"
                                        value={32}
                                        className={iconSelected === 32 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoJeepAmarillo} className="img" alt="bus" />
                                    </div>
                                    <div
                                        id="iconBus"
                                        value={24}
                                        className={iconSelected === 24 ? ESTILO_EFECTO_LUZ : ESTILO_EFECTO_SIN_LUZ}
                                        style={{ backgroundColor: "white", width: 88, height: 88 }}
                                        onClick={(e) => changeSelectedIcon(e.currentTarget)}
                                    >
                                        <img src={iconoMicroBusAmarillo} className="img" alt="bus" />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <hr />
                    <label className="font-bold">{t("title_aditional_documents")}</label>
                    <br />
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            <Select
                                options={listDocumentos}
                                isSearchable={true}
                                isClearable={true}
                                value={documentoSelected}
                                onChange={(event) => setDocumentoSelected(event)}
                                placeholder={t("label_select_document")}
                                className="w-full"
                                menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
                            {uploadingFile === false &&
                                <ButtonAddFileComponent
                                    title={"Add"}
                                    handleAdd={handleAddDocument}
                                />
                            }
                            {uploadingFile === true &&
                                <ButtonLoadingComponent
                                    title={"Loading"}
                                />
                            }
                            <input
                                id="fileUpload"
                                type="file"
                                ref={fileInputRef}
                                onChange={handleFileChange}
                                accept=".jpg,.jpeg,.png,.pdf"
                                style={{ display: 'none' }}
                            />
                        </div>
                    </div>
                    <br />
                    {renderDocuments()}
                    <br />
                    <div className=" flex items-center justify-between">
                        <button
                            type="button"
                            className={ESTILO_BOTON_LISTAR_ATRAS}
                            onClick={(handleAtrasClick)}
                        >
                            {t("label_back")}
                        </button>
                        {loading === false &&
                            <button
                                className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300"
                                onClick={handleSave}
                            >
                                Guardar
                            </button>
                        }
                        {loading === true &&
                            <button
                                className="bg-[#84B044] text-white font-semibold py-2 px-4 rounded-lg hover:bg-[#6f9239] transition duration-300 flex justify-center items-center"
                            >
                                <img className="spinner" alt="spinner" src={spinner} />
                            </button>

                        }
                    </div>

                </div >
            );
        } catch (err) {
            console.log('Vehicle render err');
            console.log(err);
            return (
                <div>
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }

    return render();
}
